"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
var portfolio_uncertainty2_chart_1 = require("./portfolio-uncertainty2.chart");
var portfolio_uncertainty2_poland_logic_1 = require("./portfolio-uncertainty2.poland.logic");
var basic_chart_component_1 = require("../basic-component/basic-chart.component");
var PortfolioUncertainty2Component = /** @class */ (function (_super) {
    __extends(PortfolioUncertainty2Component, _super);
    function PortfolioUncertainty2Component($scope, $timeout, terminologyService) {
        var _this = 
        // This constructor is necessary for inject scope and timeout.
        _super.call(this, $scope, $timeout, 'PortfolioUncertainty2') || this;
        var ctrl = _this;
        // Get terminology directly from service
        _this.terminology = terminologyService.getCurrentTerminology();
        $scope.$on('command:PORTFOLIO_UNCERTAINTY', function (event, args) {
            return ctrl.initComponent(event, args);
        });
        return _this;
    }
    PortfolioUncertainty2Component.prototype.initComponent = function (event, args) {
        this.actionMenuItem = args.actionMenuItem;
        this.currentNode = args.node;
        this.siblingNode = args.compareToNode;
        this.settings = basic_chart_component_1.loadSettings(args.treeName, args.config.data.settings);
        this.settings.currentFit = 'Monte Carlo';
        this.settings.showPDF = false;
        if (this.showTableOnReload &&
            (this.actionMenuItem == this.actionMenuItemOnReload)) {
            this.settings.showTable = this.showTableOnReload;
        }
        this.menu = this.getMenu();
        this.tableData = {
            inputData: null,
            settings: this.settings,
            mainNodeName: args.node.name,
            siblingNodeName: args.compareToNode ? args.compareToNode.name : null,
            reportOptions: this.modifyReportOptions(args.reportOptions)
        };
        this.legends = {
            legends: args.config.data.legends,
            siblingLegends: args.config.data.siblingLegends
        };
        this.graphs = args.config.data.data.DataForEachKey;
        if (this.graphs && this.graphs.length) {
            if (this.selectedGraph) {
                var graphName_1 = this.selectedGraph.Title;
                this.selectedGraph = this.graphs.find(function (item) { return item.Title === graphName_1; }) || this.graphs[0];
            }
            else {
                this.selectedGraph = this.graphs[0];
            }
            this.drawChart();
        }
        this.$timeout();
    };
    PortfolioUncertainty2Component.prototype.modifyReportOptions = function (reportOptions) {
        var groupKey = reportOptions.groupKey, colorKey = reportOptions.colorKey;
        if (colorKey && (!groupKey || (groupKey && colorKey !== groupKey))) {
            delete reportOptions.colorKey;
        }
        return reportOptions;
    };
    PortfolioUncertainty2Component.prototype.drawChart = function () {
        var graphData = JSON.parse(JSON.stringify(this.selectedGraph));
        var graphAndTable = portfolio_uncertainty2_poland_logic_1.appendPolandDataToGraph(graphData, this.settings);
        var completedGraphData = graphAndTable.graph;
        this.tableData.inputData = graphAndTable.table;
        this.tableData = JSON.parse(JSON.stringify(this.tableData));
        var timestamp = this.settings.timestampMode === 'lastRecalc' ? basic_chart_component_1.getDate(this.currentNode.lastRecalc) : basic_chart_component_1.getDate();
        var chartOptions = this.getChartOptions(completedGraphData, {
            currentNode: this.currentNode,
            legends: this.legends,
            settings: this.settings,
            timestamp: timestamp
        });
        basic_chart_component_1.makeChart(chartOptions);
    };
    PortfolioUncertainty2Component.prototype.getChartOptions = function (graph, options) {
        return portfolio_uncertainty2_chart_1.getChartOptions(graph, options);
    };
    PortfolioUncertainty2Component.prototype.changeChart = function () {
        this.menu = this.getMenu();
        this.drawChart();
    };
    PortfolioUncertainty2Component.prototype.getMenu = function () {
        var ctrl = this;
        var fitType = ctrl.settings.currentFit === 'Monte Carlo' ? 'Poland' : 'Monte Carlo';
        return [
            {
                'name': 'Display',
                'items': [{
                        'name': ctrl.settings.showTable ? 'Hide Table' : 'Show Table',
                        'toggle': ctrl.settings.showTable ? 'Show Table' : 'Hide Table',
                        'callback': function () {
                            ctrl.settings.showTable = !ctrl.settings.showTable;
                            ctrl.showTableOnReload = ctrl.settings.showTable;
                            ctrl.actionMenuItemOnReload = ctrl.actionMenuItem;
                        }
                    }, {
                        'name': ctrl.settings.showPDF ? 'Show Cumulative Distribution Function' : 'Show Probability Density Function',
                        'toggle': ctrl.settings.showPDF ? 'Show Cumulative Distribution Function' : 'Show Probability Density Function',
                        'callback': function () {
                            ctrl.settings.showPDF = !ctrl.settings.showPDF;
                            ctrl.showTableOnReload = ctrl.settings.showTable;
                            ctrl.actionMenuItemOnReload = ctrl.actionMenuItem;
                            ctrl.changeChart();
                        }
                    }]
            },
            {
                'name': 'Fit',
                'items': [{
                        'name': fitType,
                        'toggle': fitType,
                        'callback': function () {
                            ctrl.settings.currentFit = fitType;
                            ctrl.chosenFitOnReload = ctrl.settings.currentFit;
                            ctrl.actionMenuItemOnReload = angular.copy(ctrl.actionMenuItem);
                            ctrl.changeChart();
                        }
                    }]
            },
            {
                'name': 'Export',
                'items': [{
                        'name': 'Chart',
                        'callback': function () {
                            ctrl.exportCharts();
                        }
                    }, {
                        'name': 'Table',
                        'callback': function () {
                            ctrl.exportCsv();
                        }
                    }, {
                        'name': 'Table EU',
                        'callback': function () {
                            ctrl.exportCsv('EU');
                        }
                    }]
            }
        ];
    };
    PortfolioUncertainty2Component = __decorate([
        basic_chart_component_1.Component({
            bindings: {
                menu: '='
            },
            template: require("./portfolio-uncertainty2.component.html")
        }),
        __metadata("design:paramtypes", [Object, Object, Object])
    ], PortfolioUncertainty2Component);
    return PortfolioUncertainty2Component;
}(basic_chart_component_1.BasicChartComponent));
exports.PortfolioUncertainty2Component = PortfolioUncertainty2Component;
PortfolioUncertainty2Component.$inject = ['$scope', '$timeout', 'terminologyService'];
angular.module('smartorg.r6.acts.portfolioUncertainty2', []).component('portfolioUncertainty2', PortfolioUncertainty2Component);
module.exports = 'smartorg.r6.acts.portfolioUncertainty2';
//# sourceMappingURL=portfolio-uncertainty2.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/portfolio-uncertainty2/portfolio-uncertainty2.component.js